import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { MainLayoutComponent } from './core/layout/components/main-layout/main-layout.component';

import { ForgotPasswordComponent } from './features/auth/components/forgot-password/forgot-password.component';
import { LoginComponent } from './features/auth/components/login/login.component';
import { CASE_DETAILS_ROUTES } from './features/cases/case-details.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'app',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', loadComponent: () => import('./features/dashboard/components/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'calendar', loadComponent: () => import('./features/calendar/components/calendar/calendar.component').then(m => m.CalendarComponent) },
      { path: 'tasks', loadComponent: () => import('./features/tasks/components/tasks/tasks.component').then(m => m.TasksComponent) },
      { path: 'cases', loadComponent: () => import('./features/cases/components/cases/cases.component').then(m => m.CasesComponent) },
      { path: 'all-appointments', loadComponent: () => import('./features/appointments/components/all-appointments/all-appointments.component').then(m => m.AllAppointmentsComponent) },
      { path: 'profile', loadChildren: () => import('./features/profile/profile.routes').then(m => m.PROFILE_ROUTES) },
      { path: 'library', loadComponent: () => import('./features/library/library.component').then(m => m.LibraryComponent) },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }, // Default child route for authenticated users
    ],
  },
  { path: 'case-details', loadChildren: () => Promise.resolve(CASE_DETAILS_ROUTES), canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  {
    path: '**', redirectTo: 'login'
  }
];